// extracted by mini-css-extract-plugin
export default {"virtualizedDiffRow":"PullRequestVirtualizedDiffRow-module__virtualizedDiffRow__wFNpxsy"};